export const nonMobileEnrollmentCustomerTypePaths: { [key: string]: string } = {
    "NMECustomerWithHealthProfile": "defaultPharmacyCustomerTypes=PharmacyCustomerWithHealthProfile&pharmacyCustomerConfigTypes=NonMobileEnrollmentForHealthProfile",
};

export const nonMobileEnrollmentCustomerTypeMapping = {
    "NMECustomerWithHealthProfile": "Non Mobile Enrollment Customer"
};
